export default __webpack_public_path__ + "static/media/icn-inverted-male.b37818d0.svg";